import { BellOutlined, LogoutOutlined, SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import { Spin } from 'antd';
import useAuth from '@/hooks/useAuth';
import { createStyles } from 'antd-style';
import type { MenuInfo } from 'rc-menu/lib/interface';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import HeaderDropdown from '../HeaderDropdown';
import { useAuthStore } from '@/store/auth';

export type GlobalHeaderRightProps = {
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { currentUser } = useAuthStore();
  return <span className="anticon">{currentUser?.name}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ children }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { styles } = useStyles();
  const { currentUser } = useAuthStore();
  const { logout } = useAuth();

  const onMenuClick = useCallback(
    (event: MenuInfo) => {
      const { key } = event;
      if (key === 'logout') {
        try {
          logout();
        } catch (error) {
          console.error('退出登录失败:', error);
        }
        return;
      }
      if (key === 'settings') {
        navigate('/account/settings');
        return;
      }
      if (key === 'notifications') {
        navigate('/account/notifications');
        return;
      }
    },
    [logout, navigate],
  );

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!currentUser) {
    return loading;
  }

  const menuItems = [
    {
      key: 'settings',
      icon: <SettingOutlined />,
      label: t('menu.account-info'),
    },
    {
      key: 'notifications',
      icon: <BellOutlined />,
      label: t('menu.notifications'),
    },
    {
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('menu.account.logout'),
    },
  ];

  return (
    <HeaderDropdown
      menu={{
        selectedKeys: [],
        onClick: onMenuClick,
        items: menuItems,
      }}
    >
      <span className={styles.action}>{children}</span>
    </HeaderDropdown>
  );
};
